import { render, staticRenderFns } from "./SafetyConfirmationTable.vue?vue&type=template&id=38d60e83&scoped=true"
import script from "./SafetyConfirmationTable.vue?vue&type=script&lang=js"
export * from "./SafetyConfirmationTable.vue?vue&type=script&lang=js"
import style0 from "./SafetyConfirmationTable.vue?vue&type=style&index=0&id=38d60e83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d60e83",
  null
  
)

export default component.exports